import React from 'react';
import { ArtistsTerms, H2, LayoutSingleColumn, Page, PrimaryButton } from '../../components';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { useIntl } from 'react-intl';
import { isScrollingDisabled } from '../../ducks/ui.duck';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom/cjs/react-router-dom';
import { connect } from 'react-redux';

import css from './TermsAndConditionsArtistPage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

const TermsAndConditionsArtistPageComponent = props => {
  const { scrollingDisabled } = props;

  const intl = useIntl();
  const title = intl.formatMessage({ id: 'TermsAndConditionsArtistPage.title' });

  const history = useHistory();

  return (
    <Page
      title={title}
      scrollingDisabled={scrollingDisabled}
      openGraphType="website"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        name: title,
      }}
    >
      <LayoutSingleColumn
        topbar={
          <>
            <TopbarContainer currentPage="TermsAndConditionsArtistPage" />
          </>
        }
        footer={<FooterContainer />}
      >
        <div className={css.root}>
          <H2 as="h1">{title}</H2>
          <ArtistsTerms className={css.content} />
          <PrimaryButton type="button" onClick={() => history.goBack()}>
            {intl.formatMessage({ id: 'General.goBack' })}
          </PrimaryButton>
        </div>
      </LayoutSingleColumn>
    </Page>
  );
};

const mapStateToProps = state => {
  return {
    scrollingDisabled: isScrollingDisabled(state),
  };
};

const TermsAndConditionsArtistPage = compose(
  withRouter,
  connect(mapStateToProps)
)(TermsAndConditionsArtistPageComponent);

export default TermsAndConditionsArtistPage;
